import React from "react";

import { CheckIcon } from "@heroicons/react/outline";

export default function FeatureItemLeft(params) {
  return (
    <div
      className={`relative pt-20 md:pt-20 bg-featuresbg" ${
        params.blockStyle ? params.blockStyle : ""
      }`}
    >
      <div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
        <div className="px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0">
          <div>
            <div>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-badgecolor text-badgetextcolor">
                {params.badge}
              </span>
            </div>
            <div className="mt-5">
              <h2 className="text-3xl font-bold tracking-tight text-gray-800">
                {params.title}
              </h2>
              <p className="mt-4 text-lg text-gray-500">{params.description}</p>

              {/* Features */}
              <dl className="mt-10 space-y-5 hidden md:block">
                {params.features.map((item) => (
                  <div key={item.title} className="relative">
                    <dt>
                      <CheckIcon
                        className="absolute h-6 w-6 text-green-500"
                        aria-hidden="true"
                      />
                      <p className="ml-8 text-lg leading-6 font-medium text-gray-500">
                        {item.title}
                      </p>
                    </dt>
                  </div>
                ))}
              </dl>

              {/* Explore Button */}
              {params.button && (
                <div className="mt-7 md:mt-20">
                  <a
                    href={params.button.href}
                    className="inline-flex px-4 py-3 border-2 border-primary-600 font-medium rounded-md shadow-sm bg-primary-600 text-white"
                  >
                    {params.button.text} &nbsp;&nbsp;
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      />
                    </svg>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          className={`mt-12 sm:mt-16 lg:mt-0 flex content-center items-center " ${
            params.imageStyle ? params.imageStyle : ""
          }`}
        >
          <img className="w-full" src={params.image} alt="Segment Builder" />
        </div>
      </div>
    </div>
  );
}
